// extracted by mini-css-extract-plugin
module.exports = {"pointer":"StockSearch_pointer__S3D5I"};